import React, { useRef, useState, useEffect } from 'react';
import './Screenshots.css';

const Screenshots: React.FC = () => {
  const [screenshots, setScreenshots] = useState<{ id: number; alt: string; src: string }[]>([]);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Dynamically load available screenshots
    const availableScreenshots = [];
    
    // Check for screenshot files up to a reasonable number
    for (let i = 1; i <= 20; i++) {
      try {
        // Using require to dynamically check for images
        const imagePath = require(`../../assets/images/ss${i}.jpg`);
        availableScreenshots.push({
          id: i,
          alt: `Roamr App Screenshot ${i}`,
          src: imagePath
        });
      } catch (e) {
        // If image doesn't exist, break the loop
        break;
      }
    }
    
    setScreenshots(availableScreenshots);
  }, []);

  const scroll = (direction: 'left' | 'right') => {
    if (!containerRef.current) return;
    
    const container = containerRef.current;
    const scrollAmount = container.clientWidth * 0.8; // Scroll 80% of container width
    
    container.scrollBy({
      left: direction === 'right' ? scrollAmount : -scrollAmount,
      behavior: 'smooth'
    });
  };

  return (
    <div className="screenshots-horizontal">
      <button 
        className="nav-arrow left-arrow" 
        onClick={() => scroll('left')}
        aria-label="Previous screenshot"
      >
        <i className="fas fa-chevron-left"></i>
      </button>
      
      <div className="screenshots-track" ref={containerRef}>
        <div className="screenshots-inner">
          {screenshots.map((screenshot) => (
            <div key={screenshot.id} className="phone-mockup">
              <img 
                src={screenshot.src} 
                alt={screenshot.alt}
                className="screenshot-image"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
      
      <button 
        className="nav-arrow right-arrow" 
        onClick={() => scroll('right')}
        aria-label="Next screenshot"
      >
        <i className="fas fa-chevron-right"></i>
      </button>
    </div>
  );
};

export default Screenshots;